import React from "react";
import "./PrivacyPolicy.css";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="container py-5 privacy-policy">
      <div className="mb-4">
        <button
          className="btn btn-outline-primary"
          onClick={() => navigate("/")}
        >
          ⟵ Back to Home
        </button>
      </div>
      <h2 className="text-center fw-bold mb-4">Privacy Policy</h2>

      <h5 className="fw-bold mt-4">1. Information Collected</h5>
      <ul>
        <li>Contact details (e.g., name, email, phone)</li>
        <li>Website content submitted by users</li>
        <li>Technical metadata (IP, browser, etc.)</li>
      </ul>

      <h5 className="fw-bold mt-4">2. Use of Data</h5>
      <ul>
        <li>To provide, support, and maintain the Service</li>
        <li>For administrative communication</li>
        <li>For analytics and platform improvement</li>
      </ul>

      <h5 className="fw-bold mt-4">3. Data Sharing</h5>
      <ul>
        <li>No data shared with third parties unless required by law</li>
        <li>
          Hosting vendors may access limited data for technical purposes only
        </li>
      </ul>

      <h5 className="fw-bold mt-4">4. Cookies</h5>
      <ul>
        <li>We may use cookies for analytics and better UX</li>
        <li>You can disable cookies in your browser settings</li>
      </ul>

      <h5 className="fw-bold mt-4">5. Data Rights</h5>
      <ul>
        <li>You may request access or deletion of your data</li>
        <li>Contact support to exercise your data rights</li>
      </ul>

      <h5 className="fw-bold mt-4">6. Security</h5>
      <ul>
        <li>We implement industry-standard security practices</li>
        <li>However, no digital system is 100% secure</li>
      </ul>

      <h5 className="fw-bold mt-4">7. Policy Updates</h5>
      <ul>
        <li>
          Changes will be posted on our website and take effect immediately
        </li>
      </ul>

      <p className="mt-4">
        <strong>
          By using our services, you acknowledge and agree to this Privacy
          Policy.
        </strong>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
